'use strict';

export default class Product {
    constructor() {
        const $featureBlock = $('.page-node-type-product-page .view-product-feature-block');
        const $imgSrc = $('.page-node-type-product-page .view-product-page-background-image img').attr('src');

        // $featureBlock.css('background-image', `url(${$imgSrc})`);
        $('.page-node-type-product-page .region-content-top').prepend('<div class="header__image" style="background-image: url(' + $imgSrc + ')"></div>');
    }
}
